import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, Alert, ConfirmDeleteModal, SoftwareLicenseManagementService) {
        this.$state = $state;
        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.SoftwareLicenseManagementService = SoftwareLicenseManagementService;
    }

    $onInit() {
        this.$slmi = angular.copy(this.slmi);
        this.st = new SmartTable();
        this.samlAppLogo = window.env.urls.samlAppLogo;
    }

    reset() {
        this.slmi = angular.copy(this.$slmi);
    }

    notModified() {
        return angular.equals(this.$slmi, this.slmi);
    }

    save() {
        let slmiDTO = {
            'id': this.slmi.id,
            'applicationId': this.slmi.application.id,
            'licenseCount': this.slmi.licenseCount,
            'licenseCost': this.slmi.licenseCost,
            'renewalDate': this.slmi.renewalDate,
            'description': this.slmi.description
        }

        this.isSaving = true;
        this.SoftwareLicenseManagementService
            .updateSoftwareLicenseManagementInfo(this.companyId, slmiDTO)
            .then(() => this.$state.go('^', {}, {reload: 'company.software-license-management'}))
            .then(() => this.Alert('success', 'global.messages.operation-successful'))
            .finally(() => this.isSaving = false)
    }

    goBack(){
        window.history.back();
    }

    delete() {
        this.isSaving = true
		this.ConfirmDeleteModal('company.software-license-management.confirm-delete.text')
			.then(() => {
                this.SoftwareLicenseManagementService.deleteSoftwareLicenseManagementInfo(this.companyId, this.slmi.id)
                .then(() => {
                    this.Alert('success', 'global.messages.operation-successful');
                    this.$state.go('company.software-license-management', {}, {reload: true});
            })
        })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/edit/software-license-management-edit.controller.js